<div class="tea-time">
  <div class="content">
    <div class="banner">NHF Scholarship</div>
    <div id="form-pdf">
      <form
        class="form"
        [formGroup]="scholarshipForm"
        (ngSubmit)="onFormSubmit()"
        *ngIf="
          !(teacherUploaded && coachUploaded && submissionCreated);
          else confirmation
        "
      >
        <div #form class="header">NHF Scholarship Form</div>
        <div class="underline"></div>
        <div
          *ngIf="scholarshipForm.status === 'INVALID' && submitAttempt"
          class="warn invalid-form"
        >
          Warning: Please fill out all required fields highlighted in red or
          pink.
        </div>
        <div class="sub-header">PARTICIPANT INFO</div>
        <div class="fields">
          <mat-form-field class="field">
            <mat-label>First Name</mat-label>
            <input
              matInput
              [formControlName]="'first'"
              placeholder="Enter first name here..."
              [required]="true"
            />
            <mat-error> First name is required.</mat-error>
          </mat-form-field>
          <mat-form-field class="field">
            <mat-label>Last Name</mat-label>
            <input
              matInput
              [formControlName]="'last'"
              placeholder="Enter last name here..."
              [required]="true"
            />
            <mat-error> Last name is required.</mat-error>
          </mat-form-field>
          <mat-form-field class="field">
            <mat-label>Date of Birth</mat-label>
            <input
              matInput
              [formControlName]="'dob'"
              [matDatepicker]="picker"
              placeholder="MM/DD/YYYY"
              [required]="true"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="field">
            <mat-label>USATF Membership ID</mat-label>
            <input
              matInput
              [formControlName]="'usatf'"
              placeholder="Enter USATF Membership ID here..."
              [required]="true"
            />
            <mat-error> Last name is required.</mat-error>
          </mat-form-field>
          <mat-form-field class="field email">
            <mat-label>Email</mat-label>
            <input
              matInput
              [formControlName]="'email'"
              placeholder="Enter email here..."
              [required]="true"
            />
            <mat-error> Email is required.</mat-error>
          </mat-form-field>
          <mat-form-field class="field grade">
            <mat-label>Grade</mat-label>
            <mat-select [formControlName]="'grade'">
              <mat-option *ngFor="let grade of grades" [value]="grade">
                {{ grade }}
              </mat-option>
            </mat-select>
            <mat-error>Please choose your grade.</mat-error>
          </mat-form-field>
          <mat-form-field class="field school">
            <mat-label>School</mat-label>
            <input
              matInput
              [formControlName]="'school'"
              placeholder="Enter school here..."
              [required]="true"
            />
            <mat-error>Please enter your school.</mat-error>
          </mat-form-field>
        </div>
        <div class="sub-header">PARENT/GAURDIAN INFO</div>
        <div class="fields" [formGroupName]="'parent'">
          <mat-form-field class="field">
            <mat-label>First Name</mat-label>
            <input
              matInput
              [formControlName]="'first'"
              placeholder="Enter first name here..."
              [required]="true"
            />
            <mat-error> First name is required.</mat-error>
          </mat-form-field>
          <mat-form-field class="field">
            <mat-label>Last Name</mat-label>
            <input
              matInput
              [formControlName]="'last'"
              placeholder="Enter last name here..."
              [required]="true"
            />
            <mat-error> Last name is required.</mat-error>
          </mat-form-field>
          <div class="parent">
            <div
              class="prompt"
              [class.warn]="
                this.scholarshipForm
                  .get('parent')
                  .get('mother')
                  .hasError('notChecked') &&
                this.scholarshipForm.get('parent').touched
              "
            >
              What is your relation to the participant? *
            </div>
            <div class="checkboxes">
              <mat-checkbox
                class="margin"
                #parentCheckbox
                (change)="handleCheckbox($event, 'mother')"
                [formControlName]="'mother'"
                >Mother</mat-checkbox
              >
              <mat-checkbox
                class="margin"
                #parentCheckbox
                (change)="handleCheckbox($event, 'father')"
                [formControlName]="'father'"
                >Father</mat-checkbox
              >
              <mat-checkbox
                class="margin"
                #parentCheckbox
                (change)="handleCheckbox($event, 'gaurdian')"
                [formControlName]="'gaurdian'"
                >Gaurdian</mat-checkbox
              >
              <mat-checkbox
                class="margin"
                #parentCheckbox
                (change)="handleCheckbox($event, 'other')"
                [formControlName]="'other'"
                >Other</mat-checkbox
              >
            </div>
          </div>
          <mat-form-field class="field relation" *ngIf="otherRelationChecked">
            <mat-label>Relation</mat-label>
            <input
              matInput
              [formControlName]="'otherTxt'"
              placeholder="Enter relation here..."
              [required]="otherRelationChecked"
            />
            <mat-error> Relationship to participant is required.</mat-error>
          </mat-form-field>
          <mat-form-field class="field email">
            <mat-label>Email</mat-label>
            <input
              matInput
              [formControlName]="'email'"
              placeholder="Enter email here..."
              [required]="true"
            />
            <mat-error> Email is required.</mat-error>
          </mat-form-field>
          <mat-form-field class="field cell">
            <mat-label>Phone</mat-label>
            <input
              matInput
              [formControlName]="'cell'"
              placeholder="Enter phone number here..."
              [required]="true"
            />
            <mat-error *ngIf="cellForm.getError('required')">
              Phone number is required.</mat-error
            >
            <mat-error *ngIf="cellForm.getError('pattern')">
              Please enter a valid phone number of the form
              (XXX)-XXX-XXXX.</mat-error
            >
          </mat-form-field>
        </div>
        <div class="essays" [formGroupName]="'essays'">
          <div class="sub-header">ESSAYS</div>
          <div class="instructions">
            In 300 words or less, tell us about your goals and aspirations both
            on and off the track. In addition, tell us why you believe you
            deserve the NHF scholarship and anything we should take into
            consideration.
          </div>
          <mat-form-field class="example-full-width">
            <textarea
              matInput
              [formControlName]="'goalsAndAspirations'"
              [required]="true"
            ></textarea>
            <mat-error *ngIf="goalsAndAspirationsForm.getError('required')">
              This essay is required.</mat-error
            >
            <mat-error *ngIf="goalsAndAspirationsForm.getError('length')">
              This essay must be under 300 words.</mat-error
            >
          </mat-form-field>
          <div class="instructions">
            Tell us your favorite Natasha Hastings fact and one way Natasha has
            inspired you, whether its on or off the track!
          </div>
          <mat-form-field class="example-full-width">
            <textarea
              matInput
              [formControlName]="'favoriteNH'"
              [required]="true"
            ></textarea>
            <mat-error *ngIf="favoriteNHForm.getError('required')">
              This essay is required.</mat-error
            >
            <mat-error *ngIf="favoriteNHForm.getError('length')">
              This essay must be under 300 words.</mat-error
            >
          </mat-form-field>
        </div>
        <div class="sub-header">ATTACHMENTS</div>
        <input
          type="file"
          class="file-input"
          (change)="onFileSelected($event, 'coach')"
          #coachUpload
        />
        <input
          type="file"
          class="file-input"
          (change)="onFileSelected($event, 'teacher')"
          #teacherUpload
        />
        <div class="attachments">
          <div class="file-upload">
            <div class="filename">
              {{
                coachReq.filename ||
                  "Please upload a letter of recommendation from a current coach."
              }}
            </div>
            <button
              mat-mini-fab
              color="accent"
              class="upload-btn"
              (click)="coachUpload.click()"
            >
              +
            </button>
          </div>
          <div class="file-upload">
            <div class="filename">
              {{
                teacherReq.filename ||
                  "Please upload a letter of recommendation from a current teacher."
              }}
            </div>
            <button
              mat-mini-fab
              color="accent"
              class="upload-btn"
              (click)="teacherUpload.click()"
            >
              +
            </button>
          </div>
        </div>
        <div class="submission">
          <button
            *ngIf="!processingForm; else processing"
            [matTooltip]="
              'You must complete all fields before submitting this form.'
            "
            [matTooltipPosition]="'after'"
            [matTooltipDisabled]="showSuccess"
            class="submit-button"
            type="submit"
            mat-button
          >
            Submit
          </button>
          <ng-template #processing>
            <mat-spinner></mat-spinner>
          </ng-template>
        </div>
        <div class="error-attachment">
          <mat-error *ngIf="displayAttachmentWarning">
            Please make sure you have attached a letter of req from your coach
            and teacher.</mat-error
          >
        </div>
      </form>
      <ng-template #confirmation>
        <div class="confirmation-header">Confirmation</div>
        <div class="confirmation">
          Thank you {{ scholarshipForm.value.first }}, for signing up to receive
          the 2022 NHF Scholarship!
        </div>
      </ng-template>
    </div>
  </div>
</div>
